import { memo } from 'react'
import { HeaderIcon } from '@/components/icons'

const Header = memo(() => {
    return (
        <div className="">
            <div className="tw:pt-6 tw:pl-6 tw:flex tw:items-center tw:border-b tw:border-[#2B3B4C] tw:pb-4">
                <HeaderIcon />
                <h1 className="tw:!m-0 tw:!ml-1 tw:!text-[20px] tw:font-medium tw:text-white">
                    My Creatives
                </h1>
            </div>
        </div>
    )
})

Header.displayName = 'Header'

export default Header